/*
  This is the sidebar
 */

import React, {useEffect, useState} from 'react';
import URLService from "./services/URLService";

const NavBar = (props) => {
    const [classes, setClasses] = useState("")
    let navPosY;

    useEffect(() => {
        const navHandle = $('#quote-navbar-wrapper').position();
        navPosY = navHandle.top;
        $(document).on('scroll', function(e) {
            scrollListener()
        });
    }, [])

    const scrollListener = () => {
        let currentY = window.scrollY;
        if(currentY > navPosY) {
            setClasses('sticky')
        } else {
            setClasses('')
        }
    }

    const handleClick = (e)=> {
        e.preventDefault();
        URLService.redirect_to_home(); // we redirect based on where user are in the context
    }

    const text = () => {
        let quoteId = /quotes\/(\d+)\//.exec(window.location.href);
        if (quoteId ) {
            return "Back To Quote";
        } else {
            return "Back To My Quotes"
        }
    }

    return (
        <div id="quote-navbar-wrapper" className={classes}>
            <div className="row">
                <div className="small-12.medium-4.columns">
                    <button className="nice button-text left-chevron medium"  onClick={(e) => handleClick(e)}>{text()}</button>
                </div>
            </div>
        </div>
    )

}

export default NavBar;